import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, Link } from "react-router-dom";
import api from "@/lib/api";

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders/mine").then(r => setOrders(r.data));
  }, [user]);

  if (loading) return <div className="p-12 text-center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div>
      <div className="border-b border-zinc-900 px-6 md:px-12 py-8">
        <div className="tag mb-3">Account</div>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter uppercase font-[Outfit]" data-testid="account-heading">Hi, {user.name}</h1>
        <div className="text-sm text-zinc-600 mt-2">{user.email}</div>
      </div>
      <div className="px-6 md:px-12 py-8">
        <h2 className="text-2xl font-black tracking-tighter uppercase font-[Outfit] mb-4">Your Orders</h2>
        {orders.length === 0 ? (
          <div className="border border-zinc-900 p-8 text-center">
            <div className="text-sm uppercase tracking-widest font-bold font-[Outfit]">No orders yet</div>
            <Link to="/products" className="btn-brutal btn-red mt-4 inline-flex">Start Shopping</Link>
          </div>
        ) : (
          <div className="border border-zinc-900">
            {orders.map(o => (
              <div key={o.id} className="border-b border-zinc-200 last:border-b-0 p-4 flex flex-col sm:flex-row gap-3 sm:items-center" data-testid={`order-${o.id}`}>
                <div className="flex-1">
                  <div className="text-xs uppercase tracking-widest font-bold font-[Outfit] text-zinc-500">#{o.id.slice(0, 8)} · {new Date(o.created_at).toLocaleDateString()}</div>
                  <div className="font-bold mt-1">{o.items.length} item(s)</div>
                </div>
                <span className={`tag ${o.payment_status === "paid" ? "bg-[#0055ff] text-white border-[#0055ff]" : "bg-yellow-100"}`}>{o.payment_status}</span>
                <div className="text-xl font-black font-[Outfit]">${o.total.toFixed(2)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
